<template>
  <div :class="[containerStyle[size], bordered && 'rounded-xl']" class="event-card group w-full">
    <div
      class="image-block relative flex aspect-default h-fit items-center justify-center overflow-hidden rounded-2xl bg-secondary"
      :class="[imageStyles[size], bordered && 'rounded-b-none ']"
    >
      <UiPicture
        v-for="image in 2"
        :key="'image' + image"
        :src="value.imagePreview"
        :alt="value.title"
        :options="{ height: 190 * 1.5, enlarge: 1 }"
        :img-classes="image > 1 ? 'object-cover' : ''"
        :class="
          image > 1
            ? 'absolute z-0 size-full object-cover opacity-20 blur-lg inset-center'
            : 'relative z-10 h-full max-h-full max-w-full object-contain transition ease-out group-hover:scale-105'
        "
        lazy
      >
        <template v-if="image < 2" #default-image>
          <UiBackupImage
            :value="value.title"
            :alt="value.title"
            class="size-1/3 max-h-[80px] max-w-[80px] md:size-full md:max-h-[80px] md:max-w-[80px]"
          />
        </template>
      </UiPicture>

      <UiBadge
        v-if="value.minPrice && size === 'big'"
        position-x="right"
        position-y="bottom"
        class="z-10 m-2"
      >
        {{ toRub(value.minPrice) }}
      </UiBadge>
    </div>
    <div
      class="content-block flex flex-col justify-between pt-1.5"
      :class="[infoContainerStyles[size], bordered && 'rounded-b-lg px-3 pb-4 ']"
    >
      <UiTitle
        :severity="titleSeverity[size]"
        :class="titleStyles[size]"
        class="mb-1.5 text-pretty break-words text-text-main"
      >
        {{ value.title }}
      </UiTitle>
      <EventDate class="mb-auto !text-sm" :value="value" />
      <EventVenue v-if="!hideVenue" :value="value" type="text" class="text-text-tertiary" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRub } from '@/6_shared/lib'
import { UiBackupImage, UiBadge, UiPicture, UiTitle } from '@/6_shared/ui'
import { type Event } from '../../model'
import EventDate from '../EventDate/EventDate.vue'
import EventVenue from '../EventVenue/EventVenue.vue'

type PropType = {
  value: Event
  hideVenue?: boolean
  size?: 'small' | 'big'
  bordered?: boolean
}

withDefaults(defineProps<PropType>(), {
  hideVenue: false,
  size: 'small',
  bordered: false
})

const containerStyle: Record<NonNullable<PropType['size']>, string> = {
  small: 'flex',
  big: 'flex flex-col'
}

const imageStyles: Record<NonNullable<PropType['size']>, string> = {
  small: 'mr-2 min-w-1/3 max-w-1/3',
  big: 'min-w-ful w-full'
}

const infoContainerStyles: Record<NonNullable<PropType['size']>, string> = {
  small: 'min-w-2/3',
  big: 'min-w-1'
}

const titleSeverity: Record<
  NonNullable<PropType['size']>,
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
> = {
  small: 'h6',
  big: 'h5'
}

const titleStyles: Record<NonNullable<PropType['size']>, string> = {
  small: 'mb-1/2',
  big: ''
}
</script>
